// The client's live + upcoming promotions on their account page — for reps (to sell them) and staff.
// Thresholds are shown in the client's own currency, exactly as the client sees them.
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchCompanyPromotions } from '../api/discounts.js';
import { offerLine, timingLine } from '../lib/promotions.js';
import { useAuthStore } from '../stores/authStore.js';

export default function ClientPromotionsCard({ companyId }) {
  const role = useAuthStore((s) => s.user?.role);
  const [data, setData] = useState(null);
  useEffect(() => {
    fetchCompanyPromotions(companyId).then(setData).catch(() => setData({ promotions: [] }));
  }, [companyId]);
  if (!data) return null;
  const list = data.promotions || [];
  return (
    <div className="rounded-lg border border-line bg-surface p-4 shadow-sm">
      <div className="mb-2 flex items-center justify-between">
        <h3 className="text-sm font-semibold text-text-primary">Promotions</h3>
        {role === 'INTERNAL_STAFF' && (
          <Link to="/discounts" className="text-xs font-medium text-accent hover:underline">Manage →</Link>
        )}
      </div>
      {list.length === 0 ? (
        <p className="text-sm text-text-muted">No promotions for this client right now.</p>
      ) : (
        <ul className="space-y-2.5">
          {list.map((p) => (
            <li key={p.id} className="text-sm">
              <div className="flex items-center gap-2">
                <span className="font-medium text-text-primary">{p.name}</span>
                <span className={`rounded-full px-1.5 py-0.5 text-[10px] font-medium ${p.status === 'LIVE' ? 'bg-success-light text-success' : 'bg-warning-light text-warning'}`}>
                  {p.status === 'LIVE' ? 'Live' : 'Soon'}
                </span>
              </div>
              <div className="text-text-secondary">{offerLine(p, data.currency)}</div>
              {p.type === 'TIERED' && p.tiers.length > 1 && (
                <div className="text-xs tabular-nums text-text-muted">
                  {p.tiers.map((t) => `${new Intl.NumberFormat(undefined, { style: 'currency', currency: data.currency, maximumFractionDigits: 0 }).format(t.minSubtotal)} → ${t.percent}%`).join(' · ')}
                </div>
              )}
              <div className="text-xs text-text-muted">{timingLine(p)}</div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
